import { Component } from '@angular/core';

@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
//   styleUrls: ['./home.component.css']
})
export class FooterComponent {
//   title = 'home';
}